/*********************************************************
 *                  Admin users Ctrl
 *
 ********************************************************/


"use strict";

angular.module("admin")
	.controller("AdminCompaniesCtrl", ["$scope", "Utils", "companies", "$uibModal", "AdminCompaniesService", "toastr", function ($scope, Utils, companies, $uibModal, AdminCompaniesService, toastr) {

		/************************************************************************************************************
             *  SETUP
             *************************************************************************************************************/

		$scope.data = {
			companies: companies.data
		};

		var deleteModal;


		/************************************************************************************************************
             *  $scope functions
             *************************************************************************************************************/
		/**
             * Ouvrir la modal de suppression d'un client.
             */
		$scope.openDeleteModal = function (company) {
			$scope.data.entityToDelete = company;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		/************************************************************************************************************
             *  WEB SERVICE DELETE
             *************************************************************************************************************/
		$scope.deleteCompany = function (id) {
			AdminCompaniesService.deleteCompany(id)
				.then((response) => {
					const lineIds = response.data;
					function deleteLines(index) {
						if (index >= lineIds.length) {
							toastr.success("", "Compagnie supprimée");
							AdminCompaniesService.getAll().then((response) =>{
								$scope.data.companies = response.data;
								deleteModal.close();
							});
							return;
						}
						if (lineIds) {
							AdminCompaniesService.deleteLine(lineIds[index])
								.then(() => {
									deleteLines(index + 1);
								})
								.catch((response) => {
									toastr.error(response.data.message, "Problème lors de la suppression de la ligne");
								});
						}
					}

					// Commence la suppression des lignes
					deleteLines(0);
				})
				.catch((response) => {
					const data = response.data;
					toastr.error(data.message, "Problème lors de la suppression de la compagnie");
				});
		};


		/************************************************************************************************************
             *  UTILITY FUNCTION
             *************************************************************************************************************/


		$scope.deleteCanData = function () {
			AdminCompaniesService.deleteCanData()
				.then(() => {
					toastr.success("Données CAN effacées");
					AdminCompaniesService.getAll
						.then((response) => {
							$scope.companies = response.data;
						});
				})
				.catch((response) => {
					toastr.error(response.data.message, "Problème lors de l'effacement des données CAN");
				});
		};


	}]
	)
;